import states from "@/assets/estados.json"
import regiones from "@/assets/regiones.json"
import municipios from "@/assets/municipios.json"

import stateStats from '@/assets/regiones_estadistica.json'

export default {
    getStates() {
        return states
    },

    getRegionsInState(idState) {
        return regiones.filter(ele => ele.estado_clave == idState)
    },

    getCitiesInRegion(idRegion) {
        return municipios.filter(ele => ele.region == idRegion)
    },

    getStateStats(idState) {
        return stateStats.filter(ele => ele.estado_clave == idState)
    }
}